import React, { useState,useEffect } from 'react'
import Menu1 from '../Menu'
import Header from '../Header'
import Footer from '../Footer'
import { useNavigate } from "react-router";
import { Select } from 'antd'
import { DatePicker, TimePicker, Space } from 'antd'
import moment from "moment";
import {Button} from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { Config } from "../../config/config";
import { Calendar } from 'antd';
import { Popover } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import Cookie from 'js-cookie';
import Spinner from "../../UIComponents/Spinner/Spinner";
import { SavePmpSchedule,doGetPMPList,SavePmpReSchedule, CancelPmpPlanner, PMPList, selectedDataInfo, ClearData, DownloadPMPReports } from './actions/pmpService';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import * as XLSX from 'xlsx';
import Axios from 'axios';
import LZString from 'lz-string';
import dayjs from 'dayjs';

let colorObj = {
    "Scheduled":"808080",
    'Vendor Accepted' : '0000FF',
    'Vendor Rescheduled' : 'ECA0A8',
    'SOM Rescheduled' : 'ECA0A8',
    'SOM Cancelled' : 'FF0000',
    'Partial':'008000',
    'Completed':'008000' ,
    'Approved': '008000',
    '':''
}
const border= {
    top: { style: 'thin', color: { rgb: '01949A' } },
    bottom: { style: 'thin', color: { rgb: '01949A' } },
    left: { style: 'thin', color: { rgb: '01949A' } },
    right: { style: 'thin', color: { rgb: '01949A' } },
  };
let reportColumnName ={
    "s_no":"Sl No",
    "store_name":"Store Name",
    "lot":"LOT",
    "sub_category_name":"Sub Category",
    "asset_name":"Complete Available - Asset Details",
    "pmp_type":"Type Of PM",
    "amc_company_name":"AMC Company Name"
}
const { Option } = Select;

const exportToExcel = (dataSet, fileName) => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(dataSet);
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, fileName + '.xlsx');
  };
const PMPLists = () => {
    
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
    let userID = user['userId']
    const config = JSON.parse(Config);
    const apiInterface =config["api1"]
    const title = "Preventive Maintenance Planner List";
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const pmpData = useSelector(state => state.pmpList)
    const SelectedDataInfo = useSelector(state => state.pmpList?.SelectedDataInfo)
    const contractNameList = useSelector(state => state?.pmpList?.PMPDetails?.ContractNameList)
    const storeList = useSelector(state=>state?.pmpList?.PMPDetails?.StoreList)
    const vendorList = useSelector(state=>state?.pmpList?.PMPDetails?.VendorList)
    const subCategoryList = useSelector(state=>state?.pmpList?.PMPDetails?.SubCategoryList)
    const assetList = useSelector(state=>state?.pmpList?.PMPDetails?.AssetList)
    const pmpList = useSelector(state=>state?.pmpList?.PMPDetails?.PMPList)
    const existingPMPList = useSelector(state=>state?.pmpList?.PMPDetails?.ExistingPMPList)
    const pmpHistory = useSelector(state=>state?.pmpList?.PMPDetails?.PMPHistory)
    const ExistingPMPList = useSelector(state=>state?.pmpList?.PMPDetails?.ExistingPMPList)
    const TotalPMPList = useSelector(state=>state?.pmpList?.PMPDetails?.GroupPMPList)
    const [GroupPMPList,setGroupPMPList] = useState(TotalPMPList)
    const PMPReportData = useSelector(state=> state?.pmpList?.PMPReportData?.PMPReportData)
    const SubCategoryList = useSelector(state=> state?.pmpList?.PMPReportData?.SubCategoryList)
    const [reportTableData, setReportTableData] = useState([])
    const [reportSubId,setReportSubId] = useState(null);
    const [isSelectedDate,setIsSelectedDate] = useState(false)
    const [selectedDateData, setSelectedDateData] = useState([])
    const [selectedDate, setSelectedDate] = useState('')
    const [reportData,setReportData] =useState({
        startDate:null,
        endDate:null,
        storeId:null
    })
    const [reportExcelSheet, SetReportExcelSheet] = useState([]);
    const [isPMPScheduleOpen, setIsPMPScheduleOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)
    const [isSubmit, setisSubmit] = useState(false);
    const [isAllowReshedule, setIsAllowReshedule] = useState(false);
    const [asset,setAsset] = useState([]);
    const [subCategory,setSubCategory] = useState([]);
    const [allowSchedule, setAllowSchedule] = useState('')
    const [PMPStatus, setPMPStatus] = useState('')
    const [assetNewData,setAssetNewData] = useState([])
    const [calanderDate, setCalanderDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [assetNames, setAssetNames] = useState([])
    const [pmpListTableData,setPmpListTableData] = useState([])
    const [isCreateNew,setIsCreateNew] = useState(false)
    const [downloadPdfPath,setDownloadPdfPath] = useState('')
    const [assetListForSubCategory,setAssetListForSubCategory] = useState([])
    const [contractId,setContractId] = useState(0);
    const [isSchedule, setIsSchedule] = useState(false)
    const [isVendorAccepted,setIsVendorAccepted] = useState(false)
    const [isVendorRescheduled,setIsVendorRescheduled] = useState(false)
    const [isSOMRescheduled,setIsSOMRescheduled] = useState(false)
    const [isSOMCancelled,setIsSOMCancelled] = useState(false)
    const [isPartial,setIsPartial] = useState(false)
    const [isCompleted,setIsCompleted] = useState(false)
    const [yearOrMonth,setYearOrMonth] = useState(true)
    const [isReportGenerator, setIsReportGenerator] = useState(false)
    const [isModalVisible,setIsModalVisible] = useState(false)
    const [subcategoryNames, setSubcategoryNames] = useState('');
    const [storeId, setStoreId] = useState(null);
    const [vendorId,setVendorId] = useState(null);
    const [formData,setFormData] = useState({
        fedid: userID,
        storeid : 0,
        contractnameid  : 0,
        subcategoryids : [],
        assetids : [],
        pmptype : 0,
        pmpstartdate : '',
        comments : ''
    })
    const inputElement = React.useRef()
    const [reScheduleData,setRescheduleData] = useState({
        fedid:userID,
        pmpid:0,
        resheduled_type:1,
        technician:'',
    })
    const [cancellPlanner,setCancellPlanner] = useState({
        fedid:userID,
        pmpid:0,
        resheduled_type:1,
        comments:''
    })
    const [acceptPmpPlanner,setAcceptPmpPlanner] = useState({
        fedid:userID,
        pmpid:0,
        resheduled_type:0,
        technician:'',
        comments:''
    })
    const [showingData,setShowingData] = useState({
        fedid: userID,
        storeid : 0,
        contractnameid  : 0,
        subcategoryids : [],
        assetids : [],
        pmptype : 0,
        pmpstartdate :dayjs().format("YYYY-MM-DD hh:mm:ss"),
        comments : '',
    }) 
    const _doNavToAddPlanner = () => {
        setAllowSchedule('');
        setPMPStatus('')
        setShowingData({})
        setIsCreateNew(true)
        setContractId(0)
        setisSubmit(false)
        setFormData({fedid:userID,
            storeid : '',
            // contractnameid  : 0,
            subcategoryids : [],
            assetids : [],
            pmptype : '',
            pmpstartdate : '',
            comments : ''
        })
        setSubCategory([])
        setAsset([])
        setIsAllowReshedule(false)
        setIsPMPScheduleOpen(true);
        setIsEdit(false);
        setIsView(false);
        setAssetListForSubCategory([])
    }
    const _doNavToPMPReschedule = () => {
        setIsPMPScheduleOpen(false);
        // navigate({
        //     pathname:'/PMPReschedule',
        //     state:{data:reScheduleData}
        // })
        navigate('/PMPReschedule', { state: { data: reScheduleData } });
    }
    const _doNavToPMPList = () => {
        navigate("/PMPList");
        setIsPMPScheduleOpen(false);
        setIsEdit(false)
        setIsCreateNew(false);
    }
    const _doNavToViewPlanner = () => {
        setIsPMPScheduleOpen(true);
        setIsView(true);
        setIsEdit(false);
    }
    const _doNavToEditPlanner = () => {
        setIsPMPScheduleOpen(true);
        setIsView(false);
        setIsEdit(true);
    }
    const _doNavToCancelPlanner = () => {
        navigate("/PMPScheduleCancel");
    }
    const _doCloseModal = () => {
        setIsPMPScheduleOpen(false);
        setIsEdit(false)
        setIsCreateNew(false);
        // navigate('/PMPList')
        // setAssetNames([])
        // setSubcategoryNames([])
    }
    const getPMPId = (item) =>{
        console.log(item,'scheduleData inside getPMPId')
        const {sub_category_id, contract_id, pmp_start_date, store_id} = item

        let filterPmpId = pmpList.filter(ele=> ele.sub_category_id == sub_category_id && ele.contract_id == contract_id && ele.pmp_start_date == pmp_start_date && ele.store_id == store_id )
        console.log(filterPmpId,'filterPmpId')
        setDownloadPdfPath(filterPmpId.length >0 ? filterPmpId[0].pdf_path:"")
        return filterPmpId[0].id

    }
    const confirmChecking = (item) => {
        setShowingData({...showingData,
            storeid:item.store_id,
            contractnameid:item.contract_id,
            subcategoryids:[item.sub_category_id],
            assetids : [item.asset_id], 
            pmptype : item?.pmp_type, 
            pmpstartdate :item?.pmp_start_date, 
            comments : item?.som_comments,
        })
        dispatch(selectedDataInfo(item))
        setCancellPlanner({...cancellPlanner,pmpid:getPMPId(item),comments:item?.som_comments})
        setRescheduleData({
            ...reScheduleData,
            pmpid:getPMPId(item),
            technician:item.technician,
        })
        
        setIsAllowReshedule(true);
        // item.pmp_status=="" && setIsAllowReshedule(true);
        setAllowSchedule(item.allow_reshedule)
        setPMPStatus(item.pmp_status)
        item.allow_reshedule == 1  ?  _doNavToEditPlanner():
        (item.pmp_status=='SOM Cancelled' && item.allow_reshedule == 0) ? _doNavToViewPlanner():
        (item.pmp_status!='SOM Cancelled' && item.allow_reshedule == 0) && _doNavToEditPlanner();

        //item.allow_reshedule ==1 move to edit model
         //item.allow_reshedule ==0 and item.pmp_status=='SOM Cancelled' move to cancelled model 
          //item.allow_reshedule ==0 and item.pmp_status !='SOM Cancelled' move to view model 
       console.log(item,'item')
        handleContract(item.contract_id);
    }
    useEffect(()=>{
        setShowingData({...showingData,
            storeid:SelectedDataInfo?.store_id,
            contractnameid:SelectedDataInfo?.contract_id,
            // subcategoryids:SelectedDataInfo?.subcategorylist && Array.isArray(JSON.parse(SelectedDataInfo?.subcategorylist)) ?JSON.parse(SelectedDataInfo?.subcategorylist) : [SelectedDataInfo?.subcategorylist] ,
            subcategoryids:SelectedDataInfo&& SelectedDataInfo?.sub_category_id,
            assetids : SelectedDataInfo?.assetlist && Array.isArray(JSON.parse(SelectedDataInfo?.assetlist))?JSON.parse(SelectedDataInfo?.assetlist) :[SelectedDataInfo?.assetlist], 
            pmptype : SelectedDataInfo?.pmp_type, 
            pmpstartdate :SelectedDataInfo?.pmp_start_date, 
            comments : SelectedDataInfo?.som_comments,
        })
        setFormData({...formData,
            storeid:SelectedDataInfo?.store_id,
            contractnameid:SelectedDataInfo?.contract_id,
            // subcategoryids:SelectedDataInfo?.subcategorylist && Array.isArray(JSON.parse(SelectedDataInfo?.subcategorylist)) ?JSON.parse(SelectedDataInfo?.subcategorylist) : [SelectedDataInfo?.subcategorylist] ,
            subcategoryids:SelectedDataInfo&& SelectedDataInfo?.sub_category_id,
            assetids : SelectedDataInfo?.assetlist && Array.isArray(JSON.parse(SelectedDataInfo?.assetlist))?JSON.parse(SelectedDataInfo?.assetlist) :[SelectedDataInfo?.assetlist], 
            pmptype : SelectedDataInfo?.pmp_type, 
            pmpstartdate :SelectedDataInfo?.pmp_start_date, 
            comments : SelectedDataInfo?.som_comments,
        })
        if(typeof(SelectedDataInfo)!="undefined")
            setAssetListForSubCategory(SelectedDataInfo.assetlist_for_subcategory.length==1 ? [ SelectedDataInfo.assetlist_for_subcategory ]:Array.from(SelectedDataInfo.assetlist_for_subcategory.split(','),Number));

    },[SelectedDataInfo])
    // console.log(formData,'formData')
    useEffect(()=>{
        setPmpListTableData(TotalPMPList);
        setGroupPMPList(TotalPMPList)
    },[TotalPMPList])
    useEffect(()=>{
        console.log(PMPReportData,'PMPReportData')
        setReportTableData(PMPReportData)
    },[PMPReportData])
    useEffect(()=>{
        console.log(formData.pmptype,'inisde useEffect for checking pmptype')

        if(formData.pmptype==='5'&& PMPStatus == ''){
            setFormData({...formData,subcategoryids:[],assetids:[]})
            console.log(ExistingPMPList,'ExistingPMPList inside useEffect')
            let filterData = ExistingPMPList.filter(ele=>ele.store_id == showingData?.storeid).map(data=> data.excemption_list.split(','))
            console.log(filterData,'filterData inside useEffect')
            if(filterData.length !=0){
                const filterDataToNumber = filterData[0].map(Number)
                var toDelete = new Set(filterDataToNumber);
                toDelete = [...toDelete]
                let newAssetArray =[];
                for(let i=0;i<toDelete.length;i++){
                    const fetchedData = assetList.filter((ele)=>ele.asset_id == toDelete[i]).map(data=> newAssetArray.push(data))
                }
                console.log(newAssetArray,'newAssetArray inside useEffect')
                let arr = [...asset,...newAssetArray];
                const result = Object.values(
                    arr.reduce((acc, obj) => ({ ...acc, [obj.asset_id]: obj }), {})
                );
                
                console.log(result);
                setAsset(result)
            }
        }
        else if(formData.pmptype !='5' && PMPStatus == ''){
            setFormData({...formData,subcategoryids:[],assetids:[]})
            var contractInfo=contractNameList ?contractNameList?.filter(element=> element.id==contractId):[]
            // console.log(contractInfo,'contractInfo')
            contractInfo.length>0 &&getAssetData( contractInfo[0]?.store_id,asset)
        }
    },[formData.pmptype])
    useEffect(()=>{
        console.log(asset,'asset inside useEffect last')
    },[asset])
    const handleReportTableData = () =>{
        if(reportSubId==null || typeof(reportSubId) =="undefined"){
            setReportTableData(PMPReportData)
        }
        else{
            let data = [];
            let fetchedData = PMPReportData?.filter(ele=>ele.sub_category_id == reportSubId).map(e=>data.push(e))
            setReportTableData(data)
        }
    }
    const _doCellDataRender = (value) => {
        const listData = _doGetCellData(value);
        const tableData = pmpHistory?.filter(ele=>ele.pmp_id == listData?.map(element=>element.id))

        return (
            <ul className="m-calendar__data">
                {listData?.map((item, index) => (
                    // <Popover key = {index}placement="right" content={
                    //     <div className="m-popover_info">
                    //         <div className="m-popover-header">
                    //             <span className="m-header_left"></span>
                    //             <span className="m-header-right">{item.name}</span>
                    //         </div>
                    //         <div className="m-popover-content">
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-cogs"></i>
                    //                 <span className="content_info">{item.name}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-calendar-o"></i>
                    //                 <span className="content_info">{item.pmp_start_date}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-check"></i>
                    //                 <span className="content_info">{item.pmp_status}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fas fa-store"></i>
                    //                 <span className="content_info">{item.store_name}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-user-o"></i>
                    //                 <span className="content_info">{item.vendor_company_name}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-user-o"></i>
                    //                 <span className="content_info">{item.technician}</span>
                    //             </div>
                    //         </div>
                    //         <div className="m-popover-content">
                    //             {tableData.length !=0 &&
                    //             <table className='table table-bordered table-striped'>
                    //                 <thead className='bg-primary'>
                    //                     <tr>
                    //                         <td>pmp startDate </td>
                    //                         <td>pmp reschedule date </td>
                    //                         <td>pmp comments </td>
                    //                         <td>created by</td>
                    //                     </tr>
                    //                 </thead>
                    //                 <tbody>
                    //                     {
                    //                         tableData?.map((ele,index)=>
                    //                             <tr key={index}>
                    //                                 <td>{ele.pmp_start_date.slice(0,10)}</td>
                    //                                 <td>{ele.pmp_reschedules_date.slice(0,10)}</td>
                    //                                 <td>{ele.pmp_comments}</td>
                    //                                 <td>{ele.created_by}</td>
                    //                             </tr>
                    //                             )
                    //                     }
                    //                 </tbody>
                    //             </table>}
                    //         </div>
                    //     </div>
                    // }>
                        <li  
                            key={index} value={item.pmp_status}
                            style={{color:`${item.pmp_status_color}`}}
                            // onClick={() => confirmChecking(item)}
                        >
                            {item.name}
                        </li>
                    // {/* </Popover> */}
                ))}
            </ul>
        );
    }
    const _doGetCellData = (value) => {
        const date = value.format('YYYY-MM-DD');
        if(yearOrMonth){
            var listData = pmpListTableData?.filter(ele=> ele?.pmp_start_date?.slice(0,10)===date && calanderDate.slice(0,7)== date.slice(0,7))
        }
        else{
            var listData = pmpListTableData?.filter(ele=> ele?.pmp_start_date?.slice(0,10)===date)
        }
        if(typeof(listData) != 'undefined'){
            if(listData.length !=0){
                // console.log(listData,'listData')
            } 
        }
        return listData;
    }
    const handleSubcategoryAssetDetails = (contractInfo) =>{
        console.log(contractInfo,'contractInfoData')
        const subCategoryIdsArray = contractInfo[0]?.sub_category_id.replace(/[\[\]']+/g,'').split(",");
        const assetIdsArray = contractInfo[0]?.asset_id.replace(/[\[\]']+/g,'').split(",");
        console.log(subCategoryIdsArray,'subCategoryIdsArray')
        console.log(assetIdsArray,'assetIdsArray')
        setFormData({...formData, storeid:contractInfo[0].store_id})
        setShowingData({...showingData, storeid:contractInfo[0].store_id})
        let sub = []
        let asset = []
        for(let i=0;i<subCategoryIdsArray.length;i++){
            let fetchedData = subCategoryList.filter(element=>element.id==Number(subCategoryIdsArray[i]) && element.store_id == contractInfo[0].store_id).map(data =>sub.push(data))
        }
        for(let i=0;i<assetIdsArray.length;i++){
            let fetchedData = assetList.filter(element=>element.asset_id==Number(assetIdsArray[i])).map(data =>asset.push(data))
        }
        setSubCategory(sub);
        getAssetData(contractInfo[0].store_id,asset)

        // let subCatnamesInfo = []
        // for(let i=0;i<subCategoryIdsArray.length;i++){
        //     let fetchedData = sub.filter(ele=>subCategoryIdsArray[i] == ele.id).map(data =>subCatnamesInfo.push(data.name+', ') )
        // }
        // setSubcategoryNames(subCatnamesInfo)
    }
    // const [contractId,setContractId] = useState(0);
    const handleContract = (id) =>{
        setFormData({...formData,contractnameid:id})
        setContractId(id)
        var contractInfo=contractNameList.filter(element=> element.id==id)
        // console.log(contractInfo,'contractInfo')
        handleSubcategoryAssetDetails(contractInfo);
    }
    const handleSubmit = () => {
        setisSubmit(true)
        if(showingData.storeid == '') return;
        else if(contractId == '') return ;
        else if(formData.subcategoryids == '') return ;
        else if(formData.assetids == '') return;
        else if(formData.pmptype == '') return;
        else if(formData.pmpstartdate == '') return;
        else if(formData.comments == '') return;
        // formData.storeid = isNaN(formData.storeid) ? 0:Number(formData.storeid);
        formData.contractnameid = Number(contractId);
        formData.storeid = Number(showingData.storeid)
        formData.pmptype = Number(formData.pmptype)
        formData.subcategoryids = `[${formData.subcategoryids}]`;
        formData.assetids = `[${formData.assetids}]`;
        formData.pmpstartdate = formData.pmpstartdate.endsWith(' pm') ?formData.pmpstartdate.replace(' pm',''):formData.pmpstartdate.replace(' am','');
        console.log(formData,'formData inside handleSubmit')
        dispatch(SavePmpSchedule(formData))
        setIsPMPScheduleOpen(false)
    }
    const handleCancellPlanner = () =>{
        cancellPlanner.pmpid = Number(cancellPlanner.pmpid)
        cancellPlanner.resheduled_type = Number(cancellPlanner.resheduled_type)
        console.log(cancellPlanner,'cancellplanner')
        dispatch(CancelPmpPlanner(cancellPlanner))
        setIsPMPScheduleOpen(false);
        // navigate("/PMPScheduleCancel");
        
    }
    const handleAcceptPmpPlanner = () =>{

        acceptPmpPlanner.pmpid = Number(acceptPmpPlanner.pmpid)
        acceptPmpPlanner.resheduled_type = Number(acceptPmpPlanner.resheduled_type)
    }
    const getAssetData = (value,assetData)=>{
        console.log(assetData,'asset')
        // let asstinfo = assetData.map(data => data.asset_name+", ")
        let filterData = ExistingPMPList.filter(ele=>ele.store_id == value).map(data=> data.excemption_list.split(','))
        console.log(filterData,'filterData')
        if(filterData.length !=0){
            const filterDataToNumber = filterData[0].map(Number)
            var toDelete = new Set(filterDataToNumber);
            console.log(toDelete,'toDelete')
            const newArray = assetData.filter(obj=> !toDelete.has(obj.asset_id))
            console.log(newArray,'newArray')
            setAsset(newArray);
        }else{
            setAsset(assetData)
        }
        
        // console.log(asstinfo,'asstinfo')
        // console.log(SelectedDataInfo,'SelectedDataInfo')
        // if(SelectedDataInfo?.pmp_status != ''){
        //     console.log('inside setassetNames')
        //     setAssetNames(asstinfo)
        // }

    }
    const _doSelectVender = () =>{}
    const handleAssetData =(value)=>{
        setFormData({...formData,subcategoryids:value});
        let assetInfo = []
        for(let i=0;i<value.length;i++){
            let info = asset.filter(ele=>ele.sub_category_id == value[i]).map(data=>assetInfo.push(data))
        }
        setAssetNewData(assetInfo)
    }
    useEffect(() => {
        dispatch(doGetPMPList())
        return()=>{
            dispatch(ClearData())
        }
    }, []);
    

    const multiDataSet = [
        {
            
          columns: [
            { title: "Asset Name",width: { wpx: 90 } } ,//pixels width
            { title: "Allow Reshedule",width: { wpx: 90 } }, //char width
            { title: "Asset ID",  width: { wpx: 90 }},
            { title: "Asset List", width: { wpx: 90 } },
            { title: "Checkllist Score", width: { wpx: 90 } },
            { title: "Contract ID", width: { wpx: 90 } },
            { title: "ID", width: { wpx: 90 } },
            { title: "Name", width: { wpx: 90 } },
            { title: "PMP Start Date", width: { wpx: 90 } },
            { title: "PMP Status", width: { wpx: 90 } },
            { title: "PMP Type", width: { wpx: 90 } }
          ],
          data:pmpList?.map((data)=>[
              {value:data.asset_name,},
              {value:data.allow_reshedule,},
              {value:data.asset_id,},
              {value:data.assetlist,},
              {value:data.checkllist_score,},
              {value:data.contract_id,},
              {value:data.id,},
              {value:data.name,},
              {value:data.pmp_start_date,},
              {value:data.pmp_status,style: {
                fill: { patternType: "solid", fgColor: { rgb: data.pmp_status_color.slice(1) } }
              }},
              {value:data.pmp_type,
            },
          ])
        }
      ];
      
    // const [subcategoryNames, setSubcategoryNames] = useState('');
    const handleAssetNames = (value) =>{
        // console.log(value,'valuedata')
        setFormData({...formData,assetids:value})
        // let assetNamesData = []
        // for(let i=0;i<value.length;i++){
        //     let info = assetNewData.filter(ele=>ele.asset_id == value[i]).map(data =>assetNamesData.push(data.asset_name+", ") )
        //     console.log(assetNamesData,'info inside loop')
        // }
        // setAssetNames(assetNamesData)
    }
    
    const handleLegends=(value) =>{
        if(value=='Scheduled'){
            setIsSchedule(true)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'Vendor Accepted'){
            setIsSchedule(false)
            setIsVendorAccepted(true);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'Vendor Rescheduled'){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(true)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'SOM Rescheduled' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(true)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'SOM Cancelled' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(true)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'Partial' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(true)
            setIsCompleted(false)
        }
        else if(value == 'Completed' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(true)
        }
        else if(value == 'All'){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
            setPmpListTableData(GroupPMPList)
        }
        if(value == 'GetAllOrMonth'){
            setYearOrMonth(!yearOrMonth)
        }

    }
    const handleCount =(value) => {
        if(value !='All'){
            if(yearOrMonth){
                var data =GroupPMPList?.filter(ele=> ele.pmp_status ===value && calanderDate.slice(0,7)==ele.pmp_start_date.slice(0,7));
            }
            else{
                var data =GroupPMPList?.filter(ele=> ele.pmp_status ===value )
            }
            return data ? data?.length :0
        }
        else{
            if(yearOrMonth){
                return GroupPMPList? GroupPMPList?.filter(ele=>ele.pmp_start_date.slice(0,7) == calanderDate.slice(0,7)).length :0
            }
            else{
                return GroupPMPList? GroupPMPList?.length:0;
            }
        }
    }
    useEffect(()=>{
        if(isSchedule && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Scheduled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isVendorRescheduled && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Vendor Rescheduled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isVendorAccepted && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Vendor Accepted")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isSOMRescheduled && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "SOM Rescheduled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isSOMCancelled && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "SOM Cancelled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isPartial && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Partial")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isCompleted && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Completed")
            setPmpListTableData(info)
            console.log(info)
        }
    },[isSchedule,isVendorRescheduled, isVendorAccepted, isSOMRescheduled, isSOMCancelled, isPartial, isCompleted ])
    const handleGenerateExcelSheet = () =>{
        //making issubmit variable as true to update error message if any validation message didn't pass
        setisSubmit(true)
        //checking condition before api call
        if(reportData.storeId==null) return
        else if(reportData.startDate == null|| reportData.startDate =='') return
        else if(reportData.endDate == null || reportData.endDate == '') return
        //fetching config details for baseurl
        const config = JSON.parse(Config);
        const jsonData = Cookie.get('currentUser');
                  let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
        const user = JSON.parse(decompressedData) 
        //payload for api call
        let payload = {
            "start_date": reportData.startDate,
            "end_date": reportData.endDate,
            "store_id": reportData.storeId,
            "fedid": user['userId']
        }
        //api call for excell information
        Axios.post(`${config['api1']}/PMPInfo/newdownloadpmpreports`,payload)
        .then(result=>{
            //checking conditions to filter the result based on subcategory name by using reportsubid
            if(reportSubId !=null && reportSubId != ""){
                //fetching Sub category name from SubCategoryList details based on subcategoryID
                let subCategoryName = SubCategoryList.filter(ele=> ele.sub_category_id == reportSubId)
                //filtering result based on subcategoryname
                let filteredReportDetails = result.data[1].Table2.filter(report=> report.sub_category_name == subCategoryName[0]['sub_category_name'])
                generateExcelSheetInformation(filteredReportDetails)
            }else{
                generateExcelSheetInformation(result.data[1].Table2)
            }
        }).catch(error=>{
            console.log(error.message)
        })
    }
    const generateExcelSheetInformation = (reportsData)=>{
        //declaring header array
        let headers = []
        //updating headers information
        Object.keys(reportsData[0]).forEach(header=>{
            if(header.includes("week")){
                headers.push({title: header,width: { wpx: 120 },style:{
                    fill: { patternType: "solid", fgColor: { rgb: '0082c3' },
                    border: border
                }}})
            }else{
                headers.push({title:reportColumnName[header], width:{wpx:90},style:{
                    fill: { patternType: "solid", fgColor: { rgb: '0082c3' },
                    border: border
                 }}})
            }
        })
        //formating reportsData to required format
        let reportsArray = reportsData.map((ele,index)=>
            [
                ...getObjectsFromReportObject(ele)
            ]
        )
        //updating reportExcellSheet
        SetReportExcelSheet([{columns:headers,data:reportsArray}]);
        //programmatically clicking on Excell Export button to download Excell Sheet
        inputElement.current.click();
    }
    const getObjectsFromReportObject = (obj) =>{
        //getting headers information from obj
        let headers = Object.keys(obj);
        //getting schema for excell sheet
        let data = headers.map(ele=>{
           if(ele.includes('week')&& obj[ele] !=""){
            return(
                {
                    value:obj[ele],style: {
                        fill: { patternType: "solid", fgColor: { rgb: colorObj[obj[ele]]} },
                        border:border
                      }
                }
            )
           }else if(ele === "pmp_type" && obj[ele]=== "Not Planned"){
            return(
                {
                    value:obj[ele],style: {
                        fill: { patternType: "solid", fgColor: { rgb: 'FF0000'} },
                        border: border
                      }
                }
            )
           }
           return(
            {
                value:obj[ele],style:{
                    border: border
                }
            }
           )
        })
        return data;
    }
    
    function onPanelChange(value, mode) {
        setCalanderDate(value.format('YYYY-MM-DD'))
        console.log(value.format('YYYY-MM-DD'), mode);
        setIsSchedule(false)
        setIsVendorAccepted(false);
        setIsVendorRescheduled(false)
        setIsSOMRescheduled(false)
        setIsSOMCancelled(false)
        setIsPartial(false)
        setIsCompleted(false)
        setPmpListTableData(GroupPMPList)
    }
    const clearSubAsset = (value) =>{
        console.log('clearSubAsset')
        setFormData({...formData, subcategoryids:[],assetids:[]})
    }
    const clearAssetData= (value) =>{
        console.log('clearAssetData')
        console.log(formData.assetids,'formData.assetids')
        let assetInfo = []
        for(let i=0;i<value.length;i++){
            let info = asset.filter(ele=>ele.sub_category_id == value[i]).map(data=>assetInfo.push(data))
        }
        console.log(assetInfo,'assetInfo');
        let arr = []
        for(let i=0;i<formData.assetids.length;i++){
            let fetchedData = assetInfo.filter(ele=>ele.asset_id ===formData.assetids[i]).map(e=>arr.push(e.asset_id))
        }
        console.log(arr,'newAssetArray')
        setFormData({...formData,subcategoryids:value,assetids:arr})
    }
    const downloadReport = ()=>{
        // window.location.href = apiInterface+`/downloadimages?Image_id=${downloadPdfPath}`
        window.location.href = `${apiInterface}/downloadfiles?Image_id=${downloadPdfPath}&token_id=${Cookie.get('token')}`
    }
    const handleSearchReport = ()=>{
        setisSubmit(true)
        if(reportData.storeId==null) return
        else if(reportData.startDate == null|| reportData.startDate =='') return
        else if(reportData.endDate == null || reportData.endDate == '') return
        console.log(reportData,'reportData')
        const jsonData = {
            start_date:reportData.startDate,
            end_date:reportData.endDate,
            store_id:reportData.storeId,
        }
        dispatch(DownloadPMPReports(jsonData))
    }
    const handleReportGenerator = () => {
        setIsReportGenerator(true)
        setIsModalVisible(true)
    }
    const handleCloseReportGenerator = () => {
        setisSubmit(false)
        setReportData({...reportData,storeId:null,startDate:null,endDate:null})
        setReportSubId(null);
        dispatch(ClearData())
        setIsModalVisible(false);
        setIsReportGenerator(false);
    };
    const handleDownloadReport = (data) => {
        if(data.pdf_path!=""  && data.pdf_path.includes('.pdf')==true){
            // window.location.href = `${apiInterface}/downloadimages?Image_id=${data.pdf_path}`
            window.location.href = `${apiInterface}/downloadfiles?Image_id=${data.pdf_path}&token_id=${Cookie.get('token')}`
        }
    }
    const  disabledDate = (current) => {
        // const minDate = moment().add(-6, 'months');
        // const maxDate = moment().add(1, 'days');
        const minDate = dayjs().subtract(6, 'month');
        const maxDate = dayjs().add(1, 'day');
    // Disable dates before the minDate
    if (minDate && current && current < minDate.startOf('day')) {
      return true;
    }

    // Disable dates after the maxDate
    if (maxDate && current && current > maxDate.endOf('day')) {
      return true;
    }

    // Enable all other dates
    return false;
    }
    // const  disabledEndDate = (current) => {
    //     let date = moment().add(6,'month')
    //     // return current && current < moment(date,'DD-MM-YYYY').startOf('day');
    //     return [current && current > moment(date,'DD-MM-YYYY').endOf('day'),  current && current > moment().endOf('day')];
    // }
    // const [storeId, setStoreId] = useState(null);
    // const [vendorId,setVendorId] = useState(null);
    
    // set disabledDate to disable dates outside of the min and max range
    const disabledEndDate = (current) => {
        // const maxDate = moment().add(6, 'months');
        // const minDate = moment().add(1, 'days');
        const maxDate = dayjs().add(6, 'month');
        const minDate = dayjs().add(1, 'day');
    // Disable dates before the minDate
    if (minDate && current && current < minDate.startOf('day')) {
      return true;
    }

    // Disable dates after the maxDate
    if (maxDate && current && current > maxDate.endOf('day')) {
      return true;
    }

    // Enable all other dates
    return false;
  };
    const handleSearch = () =>{
        if((storeId !=null && typeof(storeId) !='undefined')&& (vendorId != null && typeof(vendorId) != 'undefined')){
            let data = TotalPMPList?.filter(ele=>ele.store_id == storeId && ele.vendor_id == vendorId)
            setGroupPMPList(data)
            setPmpListTableData(data)
        }
        else if(storeId !=null && typeof(storeId) !='undefined'){
            console.log('inside 1st else if')
            let data = TotalPMPList?.filter(ele=>ele.store_id == storeId)
            console.log(data,'data')
            setGroupPMPList(data)
            setPmpListTableData(data)
        }
        else if(vendorId != null && typeof(vendorId) != 'undefined'){
            console.log('inside 2nd else if condition')
            let data = TotalPMPList?.filter(ele=>ele.vendor_id == vendorId)
            console.log(data,'data')
            setGroupPMPList(data)
            setPmpListTableData(data)
        }
        else if((typeof(storeId) == "undefined" || storeId == null) && (typeof(vendorId) == "undefined" || vendorId == null)){
            console.log('inside 3rd else if')
            setGroupPMPList(TotalPMPList)
            setPmpListTableData(TotalPMPList)
        }
    }
    const onSelect = (value)=>{
        let listData = _doGetCellData(value)
        setSelectedDateData(listData)
        setIsSelectedDate(true)
        setSelectedDate(value.format('YYYY-MM-DD'))
    }
    const closeDateListModal = () =>{
        setIsSelectedDate(false)
    }
    const isItGreaterDate = ()=>{
        // const takenDate =moment(selectedDate);
        // const presentDate = moment();
        // return presentDate.diff(takenDate, 'days')>1?false:true
        const takenDate = dayjs(selectedDate);
        const presentDate = dayjs();
        return presentDate.diff(takenDate, 'day') >1?false:true
    }
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            {pmpData.modalOpen ? (
                <MessageBox
                    message={pmpData.message}
          // signout={"false"}
                onClose={()=>{
                    dispatch(doGetPMPList())
                    dispatch(PMPList(true))
                }}
        
                />

                ) : null}
            {pmpData?.loading &&
            <Spinner />}
            <div className='content-wrapper'>
                <div className="m-btn-block">
                    <div className="m-btn-block__container">
                        <div className="m-btn-block__icon">
                            <i className="fa fa-plus-circle" aria-hidden="true"></i>
                        </div>
                        <div className="m-btn-block__btns">
                            <button type='submit' onClick={_doNavToAddPlanner} className='btn btn-secondary deca-btn-yellow'>Schedule PMP</button>
                        </div>
                    </div>
                </div>
                <section className='content'>
                    {/* <div className="m-page__button">
                            <button type='submit' onClick={this._doNavToCancelPlanner} className='btn btn-secondary deca-btn-yellow color-red'>Cancel PMP</button>
                            <button type='submit' onClick={this._doNavToAddPlanner} className='btn btn-secondary deca-btn-yellow'>Schedule PMP</button>
                        </div> */}
                    <div className="m-panel mt-10">
                        <div className="m-pane__body p10">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className='form-group'>
                                        <label htmlFor='exampleInput'>Select store</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            onChange={(value)=>setStoreId(value)}
                                            value={storeId}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        > {
                                            storeList?.map((element,index)=>{
                                                return(
                                                    <Option key ={index} value={element.store_id}>{element.store_name}</Option>
                                                )
                                            })
                                        }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className='form-group'>
                                        <label htmlFor='exampleInput'>Select Vendor</label>
                                        <Select className="form-control"
                                            showSearch
                                            allowClear={true}
                                            onChange={(value)=>setVendorId(value)}
                                            value={vendorId}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        > {
                                            vendorList?.map((element,index)=>{
                                                return(
                                                    <Option key ={index} value={element.vendor_id}>{element.vendor_company_name}</Option>
                                                )
                                            })
                                        }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-1 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={handleSearch}>
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                                <div className="col-md-3 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportGenerator}>
                                        View Report
                                    </button>
                                </div>

                                {/* <div className="col-md-2 btn-no-lbl">
                                    <ExcelFile
                                    element={
                                        <button className="btn btn-secondary deca-btn-yellow">
                                        Export to Excel
                                        </button>
                                    }
                                    filename={"PMP List"}
                                    >

                                    <ExcelSheet dataSet={multiDataSet} name="Organization" />
                                    </ExcelFile>
                                </div> */}
                                <div className="col-md-2 btn-no-lbl" hidden>
                                <button
                                className='btn btn-secondary deca-btn-yellow'
                                onClick={() => exportToExcel(this.state.reportExcelSheet, 'Reports')}
                                >
                                Export
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className='row'>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#808080'}}><span className='dot' style={{backgroundColor:'#808080'}}></span> <button onClick={()=>handleLegends('Scheduled')} >Scheduled-<span>{handleCount('Scheduled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#0000FF'}}><span className='dot' style={{backgroundColor:'#0000FF'}}></span> <button onClick={()=>handleLegends('Vendor Accepted')}>Vendor Accepted-<span>{handleCount('Vendor Accepted')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#ECA0A8'}}><span className='dot' style={{backgroundColor:'#ECA0A8'}}></span> <button onClick={()=>handleLegends('Vendor Rescheduled')}>Vendor Rescheduled-<span>{handleCount('Vendor Rescheduled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#ECA0A8'}}><span className='dot' style={{backgroundColor:'#ECA0A8'}}></span><button onClick={()=>handleLegends('SOM Rescheduled')}>SOM Rescheduled-<span>{handleCount('SOM Rescheduled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#FF0000'}}><span className='dot' style={{backgroundColor:'#FF0000'}}></span> <button onClick={()=>handleLegends('SOM Cancelled')}>SOM Cancelled-<span>{handleCount('SOM Cancelled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#008000'}}><span className='dot' style={{backgroundColor:'#008000'}}></span> <button onClick={()=>handleLegends('Partial')}>Partial-<span>{handleCount('Partial')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#008000'}}><span className='dot' style={{backgroundColor:'#008000'}}></span> <button onClick={()=>handleLegends('Completed')}>Completed-<span>{handleCount('Completed')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#008000'}}><span className='dot' style={{backgroundColor:'#000'}}></span> <button onClick={()=>handleLegends('All')}>All-<span>{handleCount('All')}</span></button></span>
                              </div>
                            </div>
                            {/* <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#008000'}}><span className='dot' style={{backgroundColor:'#000'}}></span> <button onClick={()=>handleLegends('GetAllOrMonth')}> {yearOrMonth ? "Month":"Total"}</button></span>
                              </div>
                            </div> */}
                        </div>
                        <div className="m-panel__body bg-dark p10">
                            <div className="m-calendar">
                                {/* <button type='submit' onClick={_doNavToCancelPlanner} className='btn position btn-secondary deca-btn-yellow color-red'>Cancel PMP</button> */}
                                <Calendar cellRender={_doCellDataRender} onPanelChange={onPanelChange} onSelect={onSelect}/>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
            {
                isPMPScheduleOpen === true ?
                    <div className="m-modal">
                        <div className="m-modal__container">
                            <div className="m-modal__header">
                                {/* {
                                    isEdit === false && isView === false ?
                                        <h5 className="m-modal__title">Shedule - PMP by SOM</h5> : null
                                } */}
                                {/* {
                                    isEdit === true && isView === false ?
                                        <h5 className="m-modal__title">View - PMP by SOM</h5> : null
                                }
                                {
                                    isView === true && isEdit === false ?
                                        <h5 className="m-modal__title">Cancelled - PMP by SOM</h5> : null
                                } */}
                                {
                                    allowSchedule == 1 ?  <h5 className="m-modal__title">Edit - PMP by SOM</h5> :
                                    PMPStatus == 'SOM Cancelled' && allowSchedule ==0 ?  <h5 className="m-modal__title">Cancelled - PMP by SOM</h5> :
                                    PMPStatus == 'Vendor Accepted'  && allowSchedule == 0 ?  <h5 className="m-modal__title">View - PMP by SOM</h5>:
                                    PMPStatus == 'Completed' && allowSchedule == 0 ?  <h5 className="m-modal__title">Completed - PMP by SOM</h5>:
                                    PMPStatus == "Scheduled" && allowSchedule == 0 ?  <h5 className="m-modal__title">Scheduled -PMP by Store</h5>:
                                    PMPStatus == "Partial" && allowSchedule == 0 ?  <h5 className="m-modal__title">Partial -PMP by Store</h5>:
                                    PMPStatus == '' && allowSchedule == '' && <h5 className="m-modal__title">Schedule - PMP by SOM</h5>
                                }
                                <span className="m-modal__close" onClick={_doCloseModal}>
                                    <i className="fa fa-close"></i>
                                </span>
                            </div>
                            <div className="m-modal__body">
                                <div className="row">
                                    {/* <div className="col-md-12 text-right">
                                        <a>
                                            <span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>
                                        </a>
                                    </div> */}
                                    {
                                        isEdit === true ?
                                            <div className="col-md-12 status_remarks">
                                            {downloadPdfPath.includes('.pdf') && <span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                                            <h5 className="text-primary">View Remarks</h5>
                                            </div> : ""
                                    }
                                    {
                                        isView === true ?
                                            <div className="col-md-12 status_remarks">
                                                <span className="pmp_status text-danger">Cancelled</span>
                                                {downloadPdfPath.includes('.pdf') && <span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>}
                                                <span className="text-primary">View Vendor Remarks</span>
                                            </div> : ""
                                    }

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Contract*</label>
                                            <Select className="form-control"
                                                // disabled={isView}
                                                disabled ={isAllowReshedule? true:false}
                                                showSearch
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                onChange ={(value)=>(handleContract(value),clearSubAsset(value))}
                                                value={formData?.contractnameid}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {contractNameList?.map((element,index)=>{
                                                    return(
                                                        <Option key ={index} value={element.id} >{element.contract_name}</Option>
                                                    )
                                                })}
                                            </Select>
                                            {contractId =='' && isSubmit == true && <span style={{color:'red'}}>Please select Contract</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Store*</label>
                                            <Select className="form-control multiselect"
                                                // disabled={isView}
                                                showSearch
                                                // disabled ={isAllowReshedule? true:false}
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                disabled
                                                // onChange ={(value)=>(setFormData({...formData,storeid:value}, getAssetData(value)))}
                                                value={showingData?.storeid}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            > 
                                            {
                                                storeList?.map((element,index)=>{
                                                    return(
                                                        <Option key ={index} value={element.store_id}>{element.store_name}</Option>
                                                    )
                                                })

                                            }
                                            </Select>
                                            {/* {showingData.storeid =='' && isSubmit == true && <span style={{color:'red'}}>Please select Store</span>} */}

                                        </div>
                                    </div>
                                    {
                                        isView === true ?
                                            null :
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>PMP type*</label>
                                                    <Select className="form-control"
                                                        showSearch
                                                        disabled ={isAllowReshedule? true:false}
                                                        // onChange={_doSelectVender}
                                                        placeholder="-- Please Select --"
                                                        optionFilterProp="children"
                                                        onChange ={(value)=>setFormData({...formData,pmptype:value})}
                                                        value={formData?.pmptype}
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        <Option value='1'>Bi-Weekly</Option>
                                                        <Option value='2'>Monthly</Option>
                                                        <Option value='3'>Quaterly</Option>
                                                        <Option value='4'>Yearly</Option>
                                                        <Option value='5'>One Time</Option>
                                                    </Select>
                                            {formData.pmptype =='' && isSubmit == true && <span style={{color:'red'}}>Please select PMP type</span>}
                                                </div>
                                            </div>
                                    }
                                    {isCreateNew ?<div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Select Date & Time*</label>
                                            <DatePicker  showTime={{ format: 'hh:mm' }} use12Hours disabled ={isAllowReshedule? true:false}
                                                placeholder="Select Date & Time" format="YYYY-MM-DD hh:mm:ss a" className="form-control"
                                                onChange={(date, dateString) => setFormData({...formData,pmpstartdate:dateString})}
                                                defaultValue={formData?.pmpstartdate ? dayjs(formData?.pmpstartdate, "YYYY-MM-DD hh:mm:ss") : ''}
                                            />
                                            {formData.pmpstartdate =='' && isSubmit == true && <span style={{color:'red'}}>Please select Date & Time</span>}
                                        </div>
                                    </div>
                                    :
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Select Date & Time*</label>
                                            <input type="text" className="form-control" disabled value={formData?.pmpstartdate ||''} />
                                        </div>
                                    </div>
                                    }
                                    <div className="col-md-6">
                                        <div className="form-group select_h150">
                                            <label htmlFor='exampleInput'>Asset sub category*</label>
                                            <Select className="form-control multiselect"
                                                // disabled={isView}
                                                allowClear={true}
                                                disabled ={isAllowReshedule? true:false}
                                                mode='multiple'
                                                showSearch
                                                onChange={(value)=>(handleAssetData(value),clearAssetData(value))}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                value={formData?.subcategoryids}
                                                // onChange ={(value)=>(setFormData({...formData,subcategoryids:value}))}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            > {
                                                subCategory?.map(((element,index) =>
                                                        <Option key ={index}value={element.id}>{element.name}</Option>
                                                    ))
                                                }
                                            </Select>
                                            {/* <p style={{fontSize:14,fontWeight:600}}>{subcategoryNames}</p> */}
                                            {formData.subcategoryids =='' && isSubmit == true && <span style={{color:'red'}}>Please select Asset sub category</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group select_h150">
                                            <label htmlFor='exampleInput'>Assets*</label>
                                            <Select className="form-control multiselect"
                                                mode='multiple'
                                                allowClear={true}
                                                // disabled={isView}
                                                showSearch
                                                disabled ={isAllowReshedule? true:false}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                value={(PMPStatus == '' && allowSchedule == '') ? formData?.assetids:assetListForSubCategory }
                                                // value={formData?.assetids}
                                                onChange ={(value)=>handleAssetNames(value)}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            > {
                                                PMPStatus == '' && allowSchedule == '' ?
                                                    assetNewData?.map(((element, index) =>
                                                        <Option key = {index}value={element.asset_id}>{element.asset_name}</Option>
                                                    )):
                                                    assetList?.map(((element, index) =>
                                                        <Option key = {index}value={element.asset_id}>{element.asset_name}</Option>
                                                ))
                                                }
                                            </Select>
                                            {/* <p style={{fontSize:14,fontWeight:600}}>{assetNames}</p> */}
                                            {formData.assetids =='' && isSubmit == true && <span style={{color:'red'}}>Please select Asset</span>}

                                        </div>
                                    </div>  
                                    {<div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Add comment*</label>
                                            <input 
                                            type="text" 
                                            className="form-control" 
                                            maxLength="100"
                                            disabled={((PMPStatus == 'Vendor Accepted'||isView) && allowSchedule !=1) ? true: (allowSchedule ==0 && PMPStatus !='') ? true : false}
                                            value={isAllowReshedule ? cancellPlanner?.comments : formData.comments ||''}
                                            onChange ={(e)=> isAllowReshedule ? setCancellPlanner({...cancellPlanner,comments:e.target.value.replace(/[^\w\s]/gi, "")}):setFormData({...formData,comments:e.target.value.replace(/[^\w\s]/gi, "")})}
                                            />
                                            {formData.comments =='' && isSubmit == true && <span style={{color:'red'}}>Please Enter Your Comments</span>}
                                        </div>
                                    </div>}
                                    <div className="col-md-12 text-center">
                                        <div className="m-page__button top-space text-center">

                                            {
                                                // isEdit === true ?
                                                (allowSchedule == 1 ||PMPStatus === "Vendor Accepted")&& isItGreaterDate() &&
                                                    <>
                                                        {PMPStatus != "Vendor Accepted" &&<button type='button' className='btn muted-button  deca-btn-orange'  onClick={handleCancellPlanner}>Cancel PMP</button>}
                                                        <button type='button' onClick={_doNavToPMPReschedule}  className='btn btn-secondary deca-btn-yellow' >Re Schedule</button>
                                                    </>
                                            }
                                            {!isEdit && !isView ? <button type='button' onClick={_doNavToPMPList} className='btn btn-secondary deca-btn-yellow color-red'>Cancel</button> : null}

                                            {isEdit === false && isView === false? <button type='button' className='btn btn-secondary deca-btn-yellow' disabled ={isAllowReshedule? true:false} onClick={handleSubmit}>Submit</button> : null}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : false
            }
            {/* {
                isPMPScheduleOpen === true ?
                    <div className="overlay" onClick={_doCloseModal}>

                    </div>
                    : false
            } */}
            {
                isReportGenerator === true ?
                    <Modal title="Download Report" width={1000} closeIcon open={isModalVisible}
                        footer={[
                            <Button key="back" onClick={handleCloseReportGenerator}>
                                Cancel
                            </Button>
                        ]}>
                          <div className="row">
                          <div className="col-md-3">
                            <div className='form-group'>
                              <label htmlFor='exampleInput'>Select Store</label>
                              <Select className="form-control"
                                showSearch
                                onChange={(value)=>setReportData({...reportData,storeId:value})}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                // value={storeId}
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              > {
                                storeList?.map((element,index)=>{
                                    return(
                                        <Option key ={index} value={element.store_id}>{element.store_name}</Option>
                                    )
                                })
                            }
                              </Select>
                              {reportData.storeId == null && isSubmit == true && <span className='text-danger'>Please Select Store</span>}
                            </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                  <label htmlFor='exampleInput'>Start Date*</label>
                                  <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledDate} onChange={(date, dateString) => setReportData({...reportData,startDate:dateString})}/>
                                  {(reportData.startDate == null || reportData.startDate == '') && isSubmit == true && <span className='text-danger'>Please Select Start Date</span>}
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                  <label htmlFor='exampleInput'>End Date*</label>
                                  <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledEndDate} onChange={(date, dateString) => setReportData({...reportData,endDate:dateString})}/>
                                  {(reportData.endDate == null || reportData.endDate == '') && isSubmit == true && <span className='text-danger'>Please Select End Date</span>}
                              </div>
                          </div>
  
                          <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={()=>handleSearchReport()}>
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                      </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className='form-group'>
                                    <label htmlFor='exampleInput'>Select Subcategory</label>
                                    <Select className="form-control"
                                    showSearch
                                    onChange={(value)=>setReportSubId(value)}
                                    placeholder="-- Please Select --"
                                    optionFilterProp="children"
                                    allowClear={true}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    > {
                                    SubCategoryList?.map(((item,index) =>
                                        <Option key={index} value={item.sub_category_id}>{item.sub_category_name}</Option>
                                        ))
                                    }
                                    </Select>
                                </div>
                            </div>
                            <div className="col-md-1 btn-no-lbl">
                                <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportTableData}>
                                <i className="fa fa-search"></i>
                                </button>
                            </div>
                            <div className="col-md-1 btn-no-lbl">
                                <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleGenerateExcelSheet}>
                                    Excel Export
                                </button>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='table'>
                                    <table className='table table-striped table-bordered'>
                                        <thead className='bg-primary'>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Subcategory Name</th>
                                                <th>Asset Name</th>
                                                <th>Start Date</th>
                                                <th>Vendor Name</th>
                                                <th>Technician Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-center'>
                                            
                                            {
                                                reportTableData?.map((ele,index)=>{
                                                    return(
                                                        <tr key = {index}>
                                                            <td>{index+1}</td>
                                                            <td>{ele.sub_category_name}</td>
                                                            <td>{ele.asset_name}</td>
                                                            <td>{ele.pmp_start_date}</td>
                                                            <td>{ele.vendor_company_name}</td>
                                                            <td>{ele.technician_name}</td>
                                                            <td onClick={()=>handleDownloadReport(ele)} style={ele.pdf_path.includes('.pdf')? {cursor:'pointer'}:{cursor:'default'}}>{ele.pdf_path.includes('.pdf')&&<i className="fa fa-download"/>}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </Modal>
                    : false
            }
            {
                isSelectedDate &&
                <div className='datapopup'>
                    <div className="datapopup-header">
                        <h1>{selectedDate}</h1>
                        <span className="m-modal__close" onClick={closeDateListModal}>
                            <i className="fa fa-close"></i>
                        </span>
                    </div>
                    <div className='datapopup-body'>
                        <ul className='m-calendar__data'>
                            {selectedDateData?.map((item,index)=>(
                                <li className={item.name} key={index} value={item.pmp_status} style={{ color: `${item.pmp_status_color}` }} onClick={() => confirmChecking(item)}>
                                {item.name}
                            </li>
                            ))
                            }
                        </ul>
                    </div>
                </div>
            }
        </div>
    )
}

export default PMPLists